import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createServiceAreaOverrideRule } from '../../../api/plan-service-area-override-rules-api'
import type {
  CreatePlanServiceAreaOverrideRuleRequestDto,
  PlanServiceAreaOverrideRuleResponseDto,
} from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

export function useCreateServiceAreaOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<
    PlanServiceAreaOverrideRuleResponseDto,
    unknown,
    CreatePlanServiceAreaOverrideRuleRequestDto
  >({
    mutationFn: (body) => createServiceAreaOverrideRule(body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
